import { trackPromise } from 'react-promise-tracker';
import { DafUploadApi } from "../services/daf.upload.service";
import { FileHelper } from './FileHelper';

export const DafHelper = {
    DisplayEURegionParticipation,
    IsGMRStatusOK,
    DownloadErrorLog
};

function DisplayEURegionParticipation(flag) {
    return flag === true ? "Y" : "N";
}

const GMRStatusOKPattern = /^OK$/i;

function IsGMRStatusOK(status) {
    return status && status.match(GMRStatusOKPattern);
}

async function DownloadErrorLog(dafUploadId, alertObj) {
    trackPromise(
        DafUploadApi.downloadLog(dafUploadId)
            .then((response) => {
                FileHelper.DownloadFile(response);
            })
            .catch((error) => {
                if (alertObj) {
                    alertObj.setErrorMessage('VSS Error Log is not available.');
                }
            })
    );
}